/** Custom validators for the FGB application */
class FGBValidators {
    static Empty(control) {
        if (control.value && control.value.trim() === '') {
            return {
                empty: true
            };
        }
        return null;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { FGBValidators };
